<template>
  <div class="container">
   <form style="margin-bottom: 20px;">
      <div>
         <div class="row">
            <div class="col-lg-12 col-md-12">
                    <div class="detail-tab">
                        <!--Nav Button  -->                                            
                        <nav>                                                                     
                            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                <a class="nav-item nav-link" v-on:click="tab=1;ok1=false;ok2=false"   v-bind:class="{'active show': tab==1}" role="tab" aria-controls="nav-1" aria-selected="false">Tài khoản cá nhân</a>
                                <a class="nav-item nav-link" v-on:click="tab=2;ok1=false;ok2=false"  v-bind:class="{'active show': tab==2}"  role="tab" aria-controls="nav-3" aria-selected="true">Tài khoản doanh nghiệp</a>
                            </div>
                        </nav>
                        <!--End Nav Button  -->
                    </div>
                </div>
            <template v-if="tab==1">
            <div class="col-lg-6 col-md-6 col-sm-12">
               <div class="login__label">
                  <span>Tên tài khoản<code>*</code></span>
               </div>
               <div class="login__row">
                  <input class="register__input login__input" v-model="info.TaiKhoan"  type="text" value="" placeholder="">
               </div>
               <div class="login__label">
                  <span>Mật khẩu<code>*</code></span>
               </div>
               <div class="login__row">
                  <input style="margin-bottom: 0px;" class="register__input login__input" v-model="info.MatKhau"  type="password" value="" placeholder="">
                  <code>Mật khẩu phải chứa ít nhất 1 chữ hoa, 1 chữ thường, 1 chữ số và có độ dài trên 6 ký tự </code>
               </div>
               <div class="login__label">
                  <span>Xác nhận mật khẩu<code>*</code></span>
               </div>
               <div class="login__row">
                  <input class="register__input login__input" type="password" v-model="info.XacNhanMatKhau"  value="" placeholder="">
               </div>
               <div class="login__label">
                  <span>Họ tên<code>*</code></span>
               </div>
               <div class="login__row">
                  <input class="register__input login__input" v-model="info.HoTen" type="text" value="" placeholder="">
               </div>
               <div class="login__label">
                  <span>Ngày sinh<code>*</code></span>
               </div>
               <div class="login__row">
                  <date-picker :placeholder="'DD/MM/YYYY'" :format="'DD/MM/YYYY'" input-class="login_date" style="width: 100%;" required type="text" v-model="info.NgaySinh"   class=""></date-picker>
               </div>
               <div class="login__label">
                  <span>Số điện thoại (Nên sử dụng số di động để nhận tin nhắn thông báo khi cần thiết)<code>*</code></span>
               </div>
               <div class="login__row">
                  <input class="register__input login__input" v-model="info.SoDienThoai" type="text" value="" placeholder="">
               </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
               <div class="login__label">
                  <span>Số CMND/CCCD<code>*</code></span>
               </div>
               <div class="login__row">
                  <input class="register__input login__input" v-model="info.SoCMND" type="text" value="" placeholder="">
               </div>
               <div class="login__label">
                  <span>Ngày cấp CMND/CCCD<code>*</code></span>
               </div>
               <div class="login__row">
                  <date-picker :placeholder="'DD/MM/YYYY'" :format="'DD/MM/YYYY'" input-class="login_date" style="width: 100%;"  required type="text" v-model="info.NgayCapCMND"   class=""></date-picker>
               </div>
               <div class="login__label">
                  <span>Nơi cấp CMND/CCCD<code>*</code></span>
               </div>
               <div class="login__row">
                  <input class="register__input login__input" type="text" v-model="info.NoiCapCMND" value="" placeholder="">
               </div>
               <div class="login__label">
                  <span>Hộ khẩu thường trú<code>*</code></span>
               </div>
               <div class="login__row">
                  <input class="register__input login__input" v-model="info.DiaChi" type="text" value="" placeholder="">
               </div>
               <div class="login__label">
                  <span>Email<code>*</code></span>
               </div>
               <div class="login__row">
                  <input class="register__input login__input" v-model="info.Email" type="text" value="" placeholder="">
               </div>
               <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12">
                     <div class="login__label">
                        <span>Ảnh CMND/CCCD mặt trước<code>*</code></span>
                     </div>
                     <div class="login__row img-detail">
                        <input class="" v-on:change="handleFileUpload1()" ref="file1" type="file" value="" placeholder="">
                        <img v-if="urlCMNDTruoc" :src="urlCMNDTruoc" style="width: 90%;">
                     </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12">
                     <div class="login__label">
                        <span>Ảnh CMND/CCCD mặt sau<code>*</code></span>
                     </div>
                     <div class="login__row img-detail">
                        <input class="" ref="file2" v-on:change="handleFileUpload2()"  type="file" value="" placeholder="">
                        <img v-if="urlCMNDSau" :src="urlCMNDSau" style="width: 90%;">
                     </div>
                  </div>
               </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
               <div class="login__label">
                  <span><input class="" v-model="ok1" type="checkbox" value="" placeholder=""> Tôi cam kết tự chịu trách nhiệm với các thông tin nhập đăng ký tài khoản</span>
               </div>
               <div class="login__label">
                  <span><input class="" v-model="ok2" type="checkbox" value="" placeholder=""> Tôi cam kết tuân thủ <a href="#" style="color: #007bff;">ĐIỀU KHOẢN VÀ CHÍNH SÁCH</a> tại website đấu giá trực tuyến</span>
               </div>
            </div>
            <div class=" col-12">
               <button :disabled="!ok1||!ok2||load" v-on:click="register()" style="min-width: unset;padding: 17px 20px;background-color: #28a745;" type="button" class="btn btn-sm btn-success">Đăng ký</button>
            </div>
            </template>
            <template v-else>
            <div class="col-lg-6 col-md-6 col-sm-12">
               <div class="login__label">
                  <span>Tài khoản<code>*</code></span>
               </div>
               <div class="login__row">
                  <input class="register__input login__input" v-model="buss.TaiKhoan"  type="text" value="" placeholder="">
               </div>
               <div class="login__label">
                  <span>Mật khẩu<code>*</code></span>
               </div>
               <div class="login__row">
                  <input style="margin-bottom: 0px;" class="register__input login__input" v-model="buss.MatKhau"  type="password" value="" placeholder="">
                  <code>Mật khẩu phải chứa ít nhất 1 chữ hoa, 1 chữ thường, 1 chữ số và có độ dài trên 6 ký tự </code>
               </div>
               <div class="login__label">
                  <span>Xác nhận mật khẩu<code>*</code></span>
               </div>
               <div class="login__row">
                  <input class="register__input login__input" type="password" v-model="buss.XacNhanMatKhau"  value="" placeholder="">
               </div>
               <div class="login__label">
                  <span>Tên doanh nghiệp/Tổ chức<code>*</code></span>
               </div>
               <div class="login__row">
                  <input class="register__input login__input" v-model="buss.TenToChuc" type="text" value="" placeholder="">
               </div>
               <div class="login__label">
                  <span>Mã số doanh nghiệp/Mã số thuế<code>*</code></span>
               </div>
               <div class="login__row">
                  
                  <input class="register__input login__input" v-model="buss.MaSoThue" type="text" value="" placeholder="">
               </div>
               <div class="login__label">
                  <span>Ngày cấp số doanh nghiệp/Mã số thuế<code>*</code></span>
               </div>
               <div class="login__row">
                  <date-picker :placeholder="'DD/MM/YYYY'"  :format="'DD/MM/YYYY'" input-class="login_date" style="width: 100%;"  required type="text" v-model="buss.NgayCapMaSoThue"   class=""></date-picker>
               </div>
               <div class="login__label">
                  <span>Nơi cấp MSDN/MST<code>*</code></span>
               </div>
               <div class="login__row">
                  <input class="register__input login__input" v-model="buss.NoiCapMaSoThue" type="text" value="" placeholder="">
               </div>
               <div class="login__label">
                  <span>Trụ sở<code>*</code></span>
               </div>
               <div class="login__row">
                  <input class="register__input login__input" v-model="buss.DiaChi" type="text" value="" placeholder="">
               </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
               <div class="login__label">
                  <span>Người đại diện pháp luật<code>*</code></span>
               </div>
               <div class="login__row">
                  <input class="register__input login__input" v-model="buss.NguoiDaiDien" type="text" value="" placeholder="">
               </div>
               <div class="login__label">
                  <span>Số CMND/CCCD của người đại diện<code>*</code></span>
               </div>
               <div class="login__row">
                  <input class="register__input login__input" type="text" v-model="buss.SoCMND" value="" placeholder="">
               </div>
               <div class="login__label">
                  <span>Ngày cấp CMND/CCCD của người đại diện<code>*</code></span>
               </div>
               <div class="login__row">
                  <date-picker :placeholder="'DD/MM/YYYY'" :format="'DD/MM/YYYY'" input-class="login_date"  style="width: 100%" required type="text" v-model="buss.NgayCapCMND"   class=""></date-picker>
               </div>
               <div class="login__label">
                  <span>Nơi cấp CMND/CCCD của người đại diện<code>*</code></span>
               </div>
               <div class="login__row">
                  <input class="register__input login__input" type="text" v-model="buss.NoiCapCMND" value="" placeholder="">
               </div>
               <div class="login__label">
                  <span>Số điện thoại (Nên sử dụng số di động để nhận tin nhắn thông báo khi cần thiết)<code>*</code></span>
               </div>
               <div class="login__row">
                  <input class="register__input login__input" v-model="buss.SoDienThoai" type="text" value="" placeholder="">
               </div>
               <div class="login__label">
                  <span>Email (Nên sử dụng email gốc để nhận các thông tin về đấu giá, mã số nộp tiền)<code>*</code></span>
               </div>
               <div class="login__row">
                  <input class="register__input login__input" v-model="buss.Email" type="text" value="" placeholder="">
               </div>
               <!-- <div class="login__label">
                  <span>Ảnh giấy chứng nhận đăng ký doanh nghiệp/quyết định thành lập<code>*</code></span>
               </div>
               
               <div class="login__row  img-detail">
                  <input class="" ref="file3" v-on:change="handleFileUpload3()" type="file" value="" placeholder="">
                  <img v-if="urlGiayDangKy" :src="urlGiayDangKy" style="width: 50%;">
               </div> -->
               <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12">
                     <div class="login__label">
                        <span>Ảnh giấy chứng nhận đăng ký doanh nghiệp/quyết định thành lập mặt trước<code>*</code></span>
                     </div>
                     <div class="login__row img-detail">
                        <input class="" v-on:change="handleFileUpload3()" ref="file3" type="file" value="" placeholder="">
                        <img v-if="urlGCNDNTruoc" :src="urlGCNDNTruoc" style="width: 90%;">
                     </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12">
                     <div class="login__label">
                        <span>Ảnh giấy chứng nhận đăng ký doanh nghiệp/quyết định thành lập mặt sau<code>*</code></span>
                     </div>
                     <div class="login__row img-detail">
                        <input class="" ref="file4" v-on:change="handleFileUpload4()"  type="file" value="" placeholder="">
                        <img v-if="urlGCNDNSau" :src="urlGCNDNSau" style="width: 90%;">
                     </div>
                  </div>
               </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
               <div class="login__label">
                  <span><input class="" v-model="ok1" type="checkbox" value="" placeholder=""> Tôi cam kết tự chịu trách nhiệm với các thông tin nhập đăng ký tài khoản</span>
               </div>
               <div class="login__label">
                  <span><input class="" v-model="ok2" type="checkbox" value="" placeholder=""> Tôi cam kết tuân thủ <a href="#" style="color: #007bff;">ĐIỀU KHOẢN VÀ CHÍNH SÁCH</a> tại website đấu giá trực tuyến</span>
               </div>
            </div>
            <div class=" col-12">
               <button :disabled="!ok1||!ok2||load" v-on:click="register()" style="min-width: unset;padding: 17px 20px;background-color: #28a745;" type="button" class="btn btn-sm btn-success">Đăng ký</button>
            </div>
            </template>
         </div>
      </div>
      
      <div class="wpcf7-response-output wpcf7-display-none"></div>
      </form>
  </div>
</template>

<script>
import mixin from '@/mixins/mixin.js'
import moment from 'moment'
import DatePicker from 'vue2-datepicker';
import User from '@/common/api/user'
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/vi';
export default {
  components: {DatePicker},
  mixins: [mixin],
  name: 'HelloWorld',
  data () {
    return {
      load: false,
      ok1: false,
      ok2: false,
      tab: 1,
      buss: {
         "TaiKhoan": "",
         "MatKhau": "",
         "XacNhanMatKhau": "",
         "TenToChuc": "",
         "MaSoThue": "",
         "NgayCapMaSoThue": "",
         "NoiCapMaSoThue": "",
         "DiaChi": "",
         "SoDienThoai": "",
         "NguoiDaiDien": "",
         "SoCMND": "",
         "Email": "",
         "NgayCapCMND": "",
         "NoiCapCMND": "",
         "CNDNMatTruoc": {},
         "CNDNMatSau": {},
      },
      info: {
         "CmndMatTruoc": {},
         "CmndMatSau": {},
         "TaiKhoan": "",
         "HoTen": "",
         "NgaySinh": "",
         "SoCMND": "",
         "NgayCapCMND": "",
         "NoiCapCMND": "",
         "ChucVu": "",
         "SoDienThoai": "",
         "Email": "",
         "GhiChu": "",
         "MatKhau": "",
         "XacNhanMatKhau": "",
         "DiaChi": "",
         "CaptchaCode": "",
      },
      time1: '',
      urlCMNDTruoc: null,
      urlCMNDSau: null,
      urlGCNDNTruoc: null,
      urlGCNDNSau: null,
    }
  },
  methods: {
     handleFileUpload1(){
        this.urlCMNDTruoc = URL.createObjectURL(this.$refs.file1.files[0]);
        this.createImageBase64_1(this.$refs.file1.files[0])
     },
     handleFileUpload2(){
        this.urlCMNDSau = URL.createObjectURL(this.$refs.file2.files[0]);
        this.createImageBase64_2(this.$refs.file2.files[0])
     },
     handleFileUpload3(){
        this.urlGCNDNTruoc = URL.createObjectURL(this.$refs.file3.files[0]);
         this.createImageBase64_3(this.$refs.file3.files[0])
     },
     handleFileUpload4(){
        this.urlGCNDNSau = URL.createObjectURL(this.$refs.file4.files[0]);
         this.createImageBase64_4(this.$refs.file4.files[0])
     },
     valid(){
        var regUsername = /^[a-zA-Z0-9]+$/;
        var regCMND = /[0-9]{9}/;
        var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})");
        var regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
        var regMobile = /((09|03|07|08|05)+([0-9]{8})\b)/g;
        if (this.tab==1){
            if (this.info.TaiKhoan == ''){
               return 'Tên tài khoản không được để trống'
            }

            if (this.info.TaiKhoan.length > 50){
               return 'Tên tài khoản quá dài'
            }

            if(!regUsername.test(this.info.TaiKhoan)) {
               return 'Tài khoản chỉ chứa chữ số và chữ cái không dấu'
            }

            if (this.info.MatKhau == ''){
               return 'Mật khẩu không được để trống'
            }

            if (this.info.MatKhau != this.info.XacNhanMatKhau){
               return 'Xác nhận mật khẩu không đúng'
            }

            if(!strongRegex.test(this.info.MatKhau)) {
               return 'Mật khẩu không đúng định dạng'
            }

           if (this.info.HoTen == ''){
              return 'Họ tên không được để trống'
           }

           if (this.info.SoCMND == ''){
              return 'Số CMND/CCCD không được để trống'
           }

           if(!regCMND.test(this.info.SoCMND)) {
               return 'Số CMND/CCCD không đúng định dạng'
            }

           if (this.info.NgayCapCMND == ''){
              return 'Ngày cấp CMND/CCCD không được để trống'
           }

           if (this.info.NoiCapCMND == ''){
              return 'Nơi cấp CMND/CCCD không được để trống'
           }
           if (this.info.NgaySinh == ''){
              return 'Ngày sinh không được để trống'
           }
           if (new Date().getFullYear() - this.info.NgaySinh.getFullYear() < 18){
              return 'Ngày sinh không hợp lệ: Hệ thống dành cho người trên 18 tuổi'
           }
           if (this.info.DiaChi == ''){
              return 'Hộ khẩu thường trú không được để trống'
           }
           if (this.info.Email == ''){
              return 'Email không được để trống'
           }
           if (!regEmail.test(this.info.Email)){
              return 'Email không đúng định dạng'
           }
           if (this.info.SoDienThoai == ''){
              return 'Số điện thoại không được để trống'
           }
           if (!regMobile.test(this.info.SoDienThoai)){
              return 'Số điện thoại không đúng định dạng'
           }
           if (!this.info.CmndMatTruoc.Base64Image || this.info.CmndMatTruoc.Base64Image == ''){
              return 'Ảnh CMND/CCCD mặt trước không được để trống'
           }
           if (!this.info.CmndMatSau.Base64Image || this.info.CmndMatSau.Base64Image == ''){
              return 'Ảnh CMND/CCCD mặt sau không được để trống'
           }
        }else{
           if (this.buss.TaiKhoan == ''){
              return 'Tài khoản không được để trống'
           }
            if (this.buss.TaiKhoan.length > 50){
               return 'Tài khoản quá dài'
            }
           if (this.buss.MatKhau == ''){
              return 'Mật khẩu không được để trống'
           }
           if (this.buss.XacNhanMatKhau != this.buss.XacNhanMatKhau){
               return 'Xác nhận mật khẩu không đúng'
            }
            if(!strongRegex.test(this.buss.MatKhau)) {
               return 'Mật khẩu không đúng định dạng'
            }
           if (this.buss.NguoiDaiDien == ''){
              return 'Người đại diện pháp luật không được để trống'
           }
           if (this.buss.SoCMND == ''){
              return 'Số CMND/CCCD của người đại diện không được để trống'
           }
           if(!regCMND.test(this.buss.SoCMND)) {
               return 'Số CMND/CCCD không đúng định dạng'
            }
           if (this.buss.NgayCapCMND == ''){
              return 'Ngày cấp CMND/CCCD của người đại diện không được để trống'
           }
           if (this.buss.TenToChuc == ''){
              return 'Tên doanh nghiệp/Tổ chức không được để trống'
           }
           if (this.buss.TaiKhoan == ''){
              return 'Ảnh CMND/CCCD mặt sau không được để trống'
           }
           if (this.buss.NoiCapCMND == ''){
              return 'Nơi cấp CMND/CCCD của người đại diện không được để trống'
           }
           if (this.buss.MaSoThue == ''){
              return 'Mã số doanh nghiệp/Mã số thuế không được để trống'
           }
           if (this.buss.TaiKhoan == ''){
              return 'Ảnh CMND/CCCD mặt sau không được để trống'
           }
           if (this.buss.SoDienThoai == ''){
              return 'Số điện thoại không được để trống'
           }
           if (!regMobile.test(this.buss.SoDienThoai)){
              return 'Số điện thoại không đúng định dạng'
           }
           if (this.buss.NgayCapMaSoThue == ''){
              return 'Ngày cấp số doanh nghiệp/Mã số thuế không được để trống'
           }
           if (this.buss.Email == ''){
              return 'Số điện thoại không được để trống'
           }
           if (!regEmail.test(this.buss.Email)){
              return 'Email không đúng định dạng'
           }
           if (this.buss.NoiCapMaSoThue == ''){
              return 'Nơi cấp MSDN/MST không được để trống'
           }
           if (this.buss.DiaChi == ''){
              return 'Trụ sở không được để trống'
           }

           if (!this.buss.CNDNMatTruoc.Base64Image || this.buss.CNDNMatTruoc.Base64Image == ''){
              return 'Ảnh giấy chứng nhận đăng ký doanh nghiệp/quyết định thành lập mặt trước không được để trống'
           }

           if (!this.buss.CNDNMatSau.Base64Image || this.buss.CNDNMatSau.Base64Image == ''){
              return 'Ảnh giấy chứng nhận đăng ký doanh nghiệp/quyết định thành lập mặt sau không được để trống'
           }
        }
        return ''
     },
     createImageBase64_1(fileObject){
        const render = new FileReader();
        render.onload = (e) => {
           this.info.CmndMatTruoc.Base64Image = e.target.result;
        }
        render.readAsDataURL(fileObject)
     },
     createImageBase64_2(fileObject){
        const render = new FileReader();
        render.onload = (e) => {
           this.info.CmndMatSau.Base64Image = e.target.result;
        }
        render.readAsDataURL(fileObject)
     },
     createImageBase64_3(fileObject){
        const render = new FileReader();
        render.onload = (e) => {
           this.buss.CNDNMatTruoc.Base64Image = e.target.result;
        }
        render.readAsDataURL(fileObject)
     },
     createImageBase64_4(fileObject){
        const render = new FileReader();
        render.onload = (e) => {
           this.buss.CNDNMatSau.Base64Image = e.target.result;
        }
        render.readAsDataURL(fileObject)
     },
     register(){
        var mess = this.valid()
        if (mess != ''){
           this.$swal.fire(
              {
                  title: 'Lỗi!',
                  text: mess,
                  icon: 'error',
                  showCancelButton: false,
                  confirmButtonText: 'Đồng ý',
               }
            )
           return;
        }
         var body = {}
         if (this.tab == 1){
            body = {
               "TaiKhoan": this.info.TaiKhoan,
               "HoTen": this.info.HoTen,
               "NgaySinh": moment(String(this.info.NgaySinh)).format('MM/DD/YYYY'),
               "SoCMND": this.info.SoCMND,
               "NgayCapCMND": moment(String(this.info.NgayCapCMND)).format('MM/DD/YYYY'),
               "NoiCapCMND": this.info.NoiCapCMND,
               "SoDienThoai": this.info.SoDienThoai,
               "Email": this.info.Email,
               "GhiChu": this.info.GhiChu,
               "MatKhau": this.info.MatKhau,
               "XacNhanMatKhau": this.info.MatKhau,
               "DiaChi": this.info.DiaChi,
               "CmndMatTruoc": {
                  "FileName": "cmndtruoc.jpg",
                  "Base64Image": this.info.CmndMatTruoc.Base64Image.split(',')[1]
               },
               "CmndMatSau": {
                  "FileName": "cmndsau.jpg",
                  "Base64Image": this.info.CmndMatSau.Base64Image.split(',')[1]
               }
            }
            this.load = true;
            User.register(body)
               .then(({ data }) => {
                  this.load = false;
                  if (data.Message && data.Message != ''){
                     this.$swal.fire(
                        {
                              title: 'Lỗi!',
                              text: data.Message,
                              icon: 'error',
                              showCancelButton: false,
                              confirmButtonText: 'Đồng ý',
                           }
                        )
                     return;
                  }
                  this.$swal.fire(
                     {
                           title: 'Thành công!',
                           text: 'Quý khách đã đăng ký tài khoản thành công.',
                           icon: 'success',
                           showCancelButton: false,
                           confirmButtonText: 'Đồng ý',
                        }
                     )
                  this.$router.push("/home")
            })
         }else{
            body = { 
               "TaiKhoan": this.buss.TaiKhoan,
               "MatKhau": this.buss.MatKhau,
               "XacNhanMatKhau": this.buss.MatKhau,
               "TenToChuc": this.buss.TenToChuc,
               "MaSoThue": this.buss.MaSoThue,
               "NgayCapMaSoThue": moment(String(this.buss.NgayCapMaSoThue)).format('MM/DD/YYYY'),
               "NoiCapMaSoThue": this.buss.NoiCapMaSoThue,
               "DiaChi": this.buss.DiaChi,
               "SoDienThoai": this.buss.SoDienThoai,
               "NguoiDaiDien": this.buss.NguoiDaiDien,
               "SoCMND": this.buss.SoCMND,
               "Email": this.buss.Email,
               "NgayCapCMND": moment(String(this.buss.NgayCapCMND)).format('MM/DD/YYYY'),
               "NoiCapCMND":this.buss.NoiCapCMND,
               "CNDNMatTruoc": {
                  "FileName": "chungnhanmattruoc.jpg",
                  "Base64Image": this.buss.CNDNMatTruoc.Base64Image.split(',')[1]
               },
               "CNDNMatSau": {
                  "FileName": "chungnhanmatsau.jpg",
                  "Base64Image": this.buss.CNDNMatSau.Base64Image.split(',')[1]
               }
            }
            this.load = true;
            User.registerBussiness(body)
               .then(({ data }) => {
                  this.load = false;
                  if (data.Message && data.Message != ''){
                     this.$swal.fire(
                        {
                              title: 'Lỗi!',
                              text: data.Message,
                              icon: 'error',
                              showCancelButton: false,
                              confirmButtonText: 'Đồng ý',
                           }
                        )
                     return;
                  }
                  this.$swal.fire(
                     {
                           title: 'Thành công!',
                           text: 'Quý khách đã đăng ký tài khoản thành công.',
                           icon: 'success',
                           showCancelButton: false,
                           confirmButtonText: 'Đồng ý',
                        }
                     )
                  this.$router.push("/home")
            })
         }
     }
  },
}
</script>

<style scoped>
.register__input {
   height: 34px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Register.vue